import api from "./api";
import API_ROUTES from "./apiRoutes";
import { toast } from "react-toastify";

const handleError = (err, label) => {
  console.error(label, err);
  const message =
    err?.response?.data?.message ||
    err?.data?.message ||
    err?.data?.error ||
    err?.message ||
    "Something went wrong";
  toast.error(message);
  throw err;
};

export const getPropertyTesters = async (propertyId) => {
  try {
    const res = await api.get(API_ROUTES.societies.testers(propertyId));
    return res.data;
  } catch (err) {
    handleError(err, "GET PROPERTY TESTERS ERROR");
  }
};

export const createPropertyTester = async (propertyId, payload) => {
  try {
    const res = await api.post(API_ROUTES.societies.createTester(propertyId), payload);
    toast.success("Tester persona created successfully");
    return res.data;
  } catch (err) {
    handleError(err, "CREATE PROPERTY TESTER ERROR");
  }
};

export const updatePropertyTester = async (propertyId, userId, payload) => {
  try {
    const res = await api.put(API_ROUTES.societies.updateTester(propertyId, userId), payload);
    toast.success("Tester persona updated");
    return res.data;
  } catch (err) {
    handleError(err, "UPDATE PROPERTY TESTER ERROR");
  }
};

export const deletePropertyTester = async (propertyId, userId) => {
  try {
    const res = await api.delete(API_ROUTES.societies.deleteTester(propertyId, userId));
    toast.success("Tester persona removed");
    return res.data;
  } catch (err) {
    handleError(err, "DELETE PROPERTY TESTER ERROR");
  }
};
